module.exports = __webpack_public_path__ + "static/media/Skin01.477ac676.jpeg";